module.exports = "/_next/static/images/LeverageFacebookAds@2x-e473bcebc039a9b3cd02fae054416950.webp";